module.exports = __webpack_public_path__ + "assets/webflow.4956355b.svg";